export default "__VITE_ASSET__Bj_T2Pqo__"